import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CoursesService } from '../../../common/_services/courses-services';

@Component({
  selector: 'app-course-template',
  templateUrl: './course-template.component.html',
  styleUrls: ['./course-template.component.css']
})
export class CourseTemplateComponent implements OnInit, OnChanges {

    _title = "Add Course Template";
    insertForm: FormGroup;
    titlesList: any;
    submitted = false;
    _courseTypeId: any = 0;
    _courseTitleId: any = 0;
    isNew: any = true;
    loading = false;

    @ViewChild('select') select: MatSelect;
    @Output() close = new EventEmitter<any>();
    @Output() refreshGrid = new EventEmitter();
    @Output() refreshGridMethod = new EventEmitter<any>();
    @Input() data;

    constructor(public activeModal: NgbActiveModal,
        private _coursesService: CoursesService,
        private formBuilder: FormBuilder) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        throw new Error('Method not implemented.');
    }

    ngOnInit(): void {

        this.loading = true;

        this.insertForm = this.formBuilder.group({
            courseTitle: ['', Validators.required],
            description : [''],
            keyPoints: [''],
        });

        this.getTitlesList();
        //debugger;
        if (Object.keys(this.data).length === 0) {
            // this is add case
        }
        else {
            this.isNew = false;
            this.populateForm(this.data);
        }

        this.loading = false;
    }

    populateForm(__data: any) {
        this._title = "Edit Course Template";

        this._courseTitleId = __data.courseTitleId;
        this._courseTypeId = __data.courseTypeId + "";
        this.insertForm.controls.description.setValue(__data.courseTemplate.description);
        this.insertForm.controls.keyPoints.setValue(__data.courseTemplate.keyTopics);
    }

    populateTitleData(data: any) {
        this.insertForm.controls.subject.patchValue(data.value.subject);
        this._courseTypeId = data.value.courseTypeId + "";
        //this.insertForm.controls.description.setValue(data.value.description);
        //this.insertForm.controls.keyPoints.setValue(data.value.keyPoints);
    }
    
    getTitlesList() {

        this._coursesService.getCourseTitlesList().subscribe((result: any) => {

            if (result.success == true) {
                this.titlesList = result.data;


                if (this._title == "Edit Course Template") {
                    var obj = this.titlesList.filter(obj => obj.id === this._courseTitleId);
                    this.insertForm.controls.courseTitle.setValue(obj[0]);
                }
            } else {

                //this._commonService.error(result.data.desc);
            }

        }, (_error: any) => {
            //this.loading = false;
        })

    }


    //get i() { return this.insertForm.controls; }

    insertNewCourse() {
        debugger;
        var req = {
            courseTitle: this.insertForm.controls.courseTitle.value.title,
            courseTitleId: this.insertForm.controls.courseTitle.value.id,
            description: this.insertForm.controls.description.value,
            keyPoints: this.insertForm.controls.keyPoints.value
        };

        this._coursesService.insertCourseData(req).subscribe((result: any) => {


            if (result.success == true) {
                this.activeModal.close('Close click');
                //this.close.emit();
                this.refreshGridMethod.emit();

            } else {
                //show error popup

            }

        }, (_error: any) => {
            //this.loading = false;
        })
    }

    addOrUpdateCourseTemplate() {
        debugger;

        var req = {
            courseTitle: this.insertForm.controls.courseTitle.value.title,
            courseTitleId: this.insertForm.controls.courseTitle.value.id,
            courseId: this.data.courseId,
            description: this.insertForm.controls.description.value,
            keyPoints: this.insertForm.controls.keyPoints.value,
            webCourseId: this.data.courseTemplate?.webCourseId ?? 0,
            webUrl: this.data.courseTemplate?.webUrl ?? null,
            subjectTitle: this.data.subjectTitle,
            courseDuration: this.data.courseDuration + "",
            courseCost: this.data.courseCost + "",
            location: this.data.location,
            startDate: this.data.dates.day1Date,
            speakerName: this.data.speakerName,
            day1Date: this.data.dates.day1Date,
            day2Date: this.data.dates.day2Date,
            day3Date: this.data.dates.day3Date,
            day4Date: this.data.dates.day4Date,
            startTime: this.data.dates.startTime,
            finishTime: this.data.dates.finishTime

        };

        this._coursesService.addOrUpdateCourseTemplate(req).subscribe((result: any) => {


            if (result.success == true) {

                this.activeModal.close('Close click');
                this.refreshGrid.emit();
                //this.close.emit();

                //this.modal.dismissAll();

            } else {
                //show error popup

            }

        }, (_error: any) => {
            //this.loading = false;
        })

    }

    onInsertSubmit() {

        //if (this.isNew == true) {

        //    this.insertNewCourse();
        //}
        //else {
            
        //}
this.addOrUpdateCourseTemplate();


    }

    onModalClose(): void {
        this.close.emit();
    }

}
